import {getServerTexts as getTexts, initTexts, texts} from '../../../Localization/texts';

const entity = 'UI_SELECTLISTMODAL';

const en = {
    search: 'Search',
    ok: 'OK',
    cancel: 'Cancel',
    DirectActivationsNoResults: `We didn't find an action that matches your search.`,
    FormSonsNoResults: `We didn't find a sub-level form that matches your search.`,
    help: 'Help',
    DirectActivations: 'Actions',
    FormSons: 'Sub-level Forms'
};

const he = {
    search: 'חיפוש',
    ok: 'אישור',
    cancel: 'ביטול',
    DirectActivationsNoResults: `לא מצאנו פעולה שמתאימה לחיפוש שלך.`,
    FormSonsNoResults: `לא מצאנו מסך בן שמתאים לחיפוש שלך.`,
    help: 'עזרה',
    DirectActivations: 'פעולות',
    FormSons: 'מסכי בן'
};

const fallbacks = {
    en,
    he
};

export const mapping = {
    1: 'search',
    2: 'ok',
    3: 'cancel',
    4: 'DirectActivationsNoResults',
    5: 'help',
    6: 'directActivations',
    7: 'FormSons',
    8: 'FormSonsNoResults'
};

export function getServerTexts() {
    return getTexts(entity, mapping);
}

// init texts fallbacks accoring to the user's locale
initTexts(entity, fallbacks);

// export entity texts
// usage: import texts from './texts'
export default texts[entity];
